export const normalizeTextForSearch = (s: string): string => {
  let t = s.trim();
  t = t.replace(/\[([^\]]*)\]\([^)]*\)/g, "$1");
  t = t.replace(/\*+/g, "");
  t = t.replace(/_+/g, "");
  t = t.replace(/`+/g, "");
  t = t.replace(/\s+/g, " ").trim().toLowerCase();
  return t;
};
